import { INewAnswer } from '../../types/newAnswer';
import { TCreateAnswerRequest } from '../../repositories/newbuilding-reviews/v1/create-answer';
import { EReviewerStatus } from '../../repositories/newbuilding-reviews/entities/create_answer/CreateAnswerRequest';

export const prepareNewAnswer = (reviewId: string, newAnswer: INewAnswer): TCreateAnswerRequest => {
  return {
    reviewId,
    userName: newAnswer.data.name.value,
    reviewerStatus: newAnswer.data.userStatus.value as unknown as EReviewerStatus,
    text: newAnswer.data.answer.value,
    isAnonymous: newAnswer.data.isAnonymous.value,
  };
};
